import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'
import { trackEntitiesGenerated } from '@/utils/helpHero'
import { buildEntitiesFromDescriptionPrompt } from '@/ai/prompts'

export const generateEntitiesFromDescription = async ({
  workflow,
  cardTypes,
  userDescription,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildEntitiesFromDescriptionPrompt({
    workflow,
    cardTypes,
    userDescription,
    stream
  })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })
    trackEntitiesGenerated(response)

    return response
  } else {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    trackEntitiesGenerated(response)

    return response || null
  }
}
